// extracted by mini-css-extract-plugin
export default {"GoBack":"ForgotPwdForm_GoBack__23PYH","backLogin":"ForgotPwdForm_backLogin__rF+jm"};